import { render, staticRenderFns } from "./EmployeeClassifications.vue?vue&type=template&id=b4668cd4"
import script from "./EmployeeClassifications.vue?vue&type=script&lang=js"
export * from "./EmployeeClassifications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports